import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrgGuestFeedbackCsvUploadsSidebarQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrgGuestFeedbackCsvUploadsSidebarQuery = { __typename?: 'Query', OrgGuestFeedbackCsvUploads: { __typename?: 'OrgGuestFeedbackCsvUploads', objects: Array<{ __typename?: 'OrgGuestFeedbackCsvUpload', id: string, fileUrl: string, fileName?: string | null, feedbackDateColumn: string, feedbackTextColumn: string, ratingColumn: string, locationColumn: string, feedbacks: Array<{ __typename?: 'GuestFeedback', id: string, text?: string | null, rating?: number | null, date: string, csvUploadLocation?: { __typename?: 'GuestFeedbackCsvUploadLocation', id: string, locationName: string } | null }>, locations: Array<{ __typename?: 'OrgGuestFeedbackCsvUploadLocation', id: string, locationName: string, location: { __typename?: 'Location', id: number, name: string } }> }> } };


export const OrgGuestFeedbackCsvUploadsSidebarDocument = gql`
    query OrgGuestFeedbackCsvUploadsSidebar {
  OrgGuestFeedbackCsvUploads {
    objects {
      id
      fileUrl
      fileName
      feedbackDateColumn
      feedbackTextColumn
      ratingColumn
      locationColumn
      feedbacks {
        id
        text
        rating
        date
        csvUploadLocation {
          id
          locationName
        }
      }
      locations {
        id
        locationName
        location {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useOrgGuestFeedbackCsvUploadsSidebarQuery__
 *
 * To run a query within a React component, call `useOrgGuestFeedbackCsvUploadsSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgGuestFeedbackCsvUploadsSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgGuestFeedbackCsvUploadsSidebarQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgGuestFeedbackCsvUploadsSidebarQuery(baseOptions?: Apollo.QueryHookOptions<OrgGuestFeedbackCsvUploadsSidebarQuery, OrgGuestFeedbackCsvUploadsSidebarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgGuestFeedbackCsvUploadsSidebarQuery, OrgGuestFeedbackCsvUploadsSidebarQueryVariables>(OrgGuestFeedbackCsvUploadsSidebarDocument, options);
      }
export function useOrgGuestFeedbackCsvUploadsSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgGuestFeedbackCsvUploadsSidebarQuery, OrgGuestFeedbackCsvUploadsSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgGuestFeedbackCsvUploadsSidebarQuery, OrgGuestFeedbackCsvUploadsSidebarQueryVariables>(OrgGuestFeedbackCsvUploadsSidebarDocument, options);
        }
export type OrgGuestFeedbackCsvUploadsSidebarQueryHookResult = ReturnType<typeof useOrgGuestFeedbackCsvUploadsSidebarQuery>;
export type OrgGuestFeedbackCsvUploadsSidebarLazyQueryHookResult = ReturnType<typeof useOrgGuestFeedbackCsvUploadsSidebarLazyQuery>;
export type OrgGuestFeedbackCsvUploadsSidebarQueryResult = Apollo.QueryResult<OrgGuestFeedbackCsvUploadsSidebarQuery, OrgGuestFeedbackCsvUploadsSidebarQueryVariables>;